import React from 'react'
import { styled, FloraVariants, forwardRef } from '@grupoboticario/flora-react-system'
import { HTMLFloraProps } from '@grupoboticario/flora-react-utils'
import { TableCellText } from './TableCellText'

const StyledTableCell = styled('td', {
  padding: '$2',
  backgroundColor: '$backgroundPrimary',
  height: '$12',
  verticalAlign: 'middle',
  '&:first-of-type': {
    borderTopLeftRadius: '$medium',
    borderBottomLeftRadius: '$medium',
  },
  '&:last-of-type': {
    borderTopRightRadius: '$medium',
    borderBottomRightRadius: '$medium',
  },
  '* + *': {
    marginLeft: '$2',
  },
  variants: {
    hasIcon: {
      true: {
        paddingRight: '$0',
        width: '$10',
      },
    },
    isTruncated: {
      true: {
        position: 'relative',
        span: {
          position: 'absolute',
          left: '$2',
          right: '$2',
          top: '50%',
          transform: 'translateY(-50%)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
    },
  },
})

export type TableCellProps = HTMLFloraProps<'td'> &
  FloraVariants<typeof StyledTableCell> & {
    asChild?: boolean
  }

export const TableCell = forwardRef<'td', TableCellProps>(
  ({ align = 'center', asChild = false, children, ...props }, forwardedRef) => {
    return (
      <StyledTableCell ref={forwardedRef} data-flora="table-cell" align={align} {...props}>
        {asChild ? <>{children}</> : <TableCellText>{children}</TableCellText>}
      </StyledTableCell>
    )
  },
)
